<div class="loading-screen" [class.loading-screen--inline]="!fullScreen()">
  <div class="glass-container">
    <fa-icon [icon]="icon()" class="loader-icon"></fa-icon>
    <div class="loading-bar-container">
      <div class="loading-bar-progress"></div>
    </div>
    <span class="loading-text">{{ text() }}</span>
  </div>
</div>
